import { FileSearchOutlined } from '@ant-design/icons';

import LogPage from '../pages/LogPage/LogPage';

import { SiteMap } from './index';

export const AUDIT_LOG_EMAILS = ['kenz@gooduncles.com', 'hubert@gooduncles.com'];

export const logRoutes: SiteMap = {
  log: {
    title: '로그 관리',
    page: LogPage,
    icon: <FileSearchOutlined />,
    key: '/log',
    role: ['admin'],
    children: [
      {
        label: '감사 로그',
        icon: null,
        key: '/log/audit',
        emails: AUDIT_LOG_EMAILS,
      },
      {
        label: '앱 로그',
        icon: null,
        key: '/log/commerce',
      },
    ],
  },
};
